import React from 'react';
import './LoadingScreen.css';

const APP_LOGO_SRC = `${process.env.PUBLIC_URL}/logo512.png`;

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="halo-container">
          <HaloIcon />
        </div>
        <h1 className="loading-title">Archangel AI</h1>
      </div>
    </div>
  );
};

const HaloIcon = () => (
  <div className="halo-logo">
    <img src={APP_LOGO_SRC} alt="Archangel AI logo" width={224} height={224} className="halo-svg" />
    {/* <span className="halo-text">Halo Search</span> */}
  </div>
);

export default LoadingScreen; 